import { gated_route, VITE_API_URL } from "@/constants";
import type { AuthFetchParams } from "./global";

export async function isGated(
  params: AuthFetchParams,
  handleTokenInvalid: () => Promise<void>,
) {
  const res = await fetch(`${VITE_API_URL}${gated_route}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${params.token}`,
      "X-Inventoree-Organization": params.orgId,
    },
    credentials: "include",
  });

  const access = res.headers.get("access-token");
  if (access) params.setToken(access);

  if (res.status == 401) {
    handleTokenInvalid();
    return;
  }

  if (!res.ok) {
    return {
      is_gated: false,
    };
  }

  return (await res.json()) as {
    is_gated: boolean;
  };
}
